import React from 'react';
import { generateCharacterSVG } from '../utils/characterSVG';
import { useLanguage } from '../contexts/LanguageContext';

const CharacterGrid = ({ currentCharacter, unlockedCharacters, characterColors, onCharacterChange }) => {
  const { t } = useLanguage();

  const characters = [
    { id: 'unicorn', unlockText: t('unlockConditions.default') },
    { id: 'dragon', unlockText: t('unlockConditions.practice10min') },
    { id: 'panda', unlockText: t('unlockConditions.practice20min') },
    { id: 'fox', unlockText: t('unlockConditions.try5speeds') },
    { id: 'alien', unlockText: t('unlockConditions.tryAllAccessories') },
    { id: 'robot', unlockText: t('unlockConditions.practice1hour') },
    { id: 'wizard', unlockText: t('unlockConditions.practice2hours') },
    { id: 'ninja', unlockText: t('unlockConditions.tryAllTimeSigs') },
    { id: 'princess', unlockText: t('unlockConditions.unlockAllOthers') },
    { id: 'superhero', unlockText: t('unlockConditions.completeAllAchievements') }
  ];

  // 只有最後兩個角色顯示為神秘角色
  const isMysteryCharacter = (characterId) => {
    return characterId === 'princess' || characterId === 'superhero';
  };

  const handleCharacterClick = (characterId) => {
    if (unlockedCharacters.includes(characterId)) {
      onCharacterChange(characterId);
    }
  };

  return (
    <div className="bg-white dark:bg-gray-800 rounded-3xl p-6 shadow-xl">
      <h3 className="text-xl font-semibold mb-6 text-center text-gray-700 dark:text-gray-200">
        🦄 {t('characterSelection')}
      </h3>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
        {characters.map(character => {
          const isUnlocked = unlockedCharacters.includes(character.id);
          const isSelected = currentCharacter === character.id;
          const isMystery = isMysteryCharacter(character.id) && !isUnlocked;

          return (
            <div
              key={character.id}
              onClick={() => handleCharacterClick(character.id)}
              className={`relative p-4 rounded-2xl transition-all duration-200 cursor-pointer text-center ${
                isSelected
                  ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-lg transform scale-105'
                  : isUnlocked
                  ? 'bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 hover:scale-105'
                  : 'bg-gray-100 dark:bg-gray-700 opacity-50 cursor-not-allowed'
              }`}
            >
              <div className="w-16 h-16 mx-auto mb-3 flex items-center justify-center">
                {isMystery ? (
                  <div className="w-full h-full bg-gray-400 dark:bg-gray-600 rounded-full flex items-center justify-center">
                    <span className="text-2xl">❓</span>
                  </div>
                ) : (
                  <div
                    className="w-full h-full"
                    dangerouslySetInnerHTML={{
                      __html: generateCharacterSVG(
                        character.id,
                        characterColors[character.id] || '#5D5CDE'
                      )
                    }}
                  />
                )}
              </div>
              <p
                className={`text-xs text-center w-full font-medium mb-2 ${
                  isSelected ? 'text-white' : 'text-gray-700 dark:text-gray-200'
                }`}
              >
                {isMystery ? t('mysteryCharacter') : t(`characters.${character.id}.name`)}
              </p>

              {!isUnlocked && (
                <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-60 rounded-2xl">
                  <div className="text-white text-center p-2">
                    <div className="text-2xl mb-1">🔒</div>
                    <p className="text-xs leading-tight text-center w-full mx-auto">{character.unlockText}</p>
                  </div>
                </div>
              )}

              {isSelected && (
                <div className="absolute -top-2 -right-2 w-6 h-6 bg-yellow-400 rounded-full flex items-center justify-center shadow-lg">
                  <span className="text-xs font-bold">✓</span>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CharacterGrid;